import {Injectable} from "@angular/core";
import {SearchFilterModel} from "../models/SearchFilter-model";
import {FormGroup, FormControl, Validators} from "@angular/forms";

@Injectable({
    providedIn: 'root'
})
export class LocalStorageService {
    constructor() {
    }


    saveFilters(filterKey: string, filters: SearchFilterModel[]) {
        localStorage.setItem(filterKey, JSON.stringify(filters));
    }

    getFilters(filterKey: string): SearchFilterModel[] {
        const savedFilters = localStorage.getItem(filterKey);
        return savedFilters ? JSON.parse(savedFilters) : [];
    }


    clearFilters(filterKey: string) {
        localStorage.removeItem(filterKey);
    }

    clearAllFilterKeys(): void {
        // Obriši sve ključeve koji sadrže "filter" u nazivu
        Object.keys(localStorage).forEach(key => {
            if (key.toLowerCase().includes('filter')) {
                localStorage.removeItem(key);
                console.log(`Removed filter key: ${key}`);
            }
        });

        console.log('All filter keys cleared on logout');
    }



    createFormGroupFromFilters(savedFilters: SearchFilterModel[], displayedColumns: string[]): FormGroup {
        const formGroup = new FormGroup({});
        const allAvailableOptions = ['hitRate', 'tuningName', ...displayedColumns]; // include enum values here

        savedFilters.forEach((filter, index) => {
            const optionValue = filter.option && allAvailableOptions.includes(filter.option)
                ? filter.option
                : allAvailableOptions[0];

            const control = new FormGroup({
                'option': new FormControl(optionValue),
                'value': new FormControl(filter.value, Validators.required),
                'hitRateMin' : new FormControl(filter.hitRateMin as number),
                'hitRateMax' : new FormControl(filter.hitRateMax as number)
            });

            formGroup.addControl(`control-${index + 1}`, control);
        });

        return formGroup;
    }
}
